import { render, staticRenderFns } from "./v_EmailBoughtTicket.vue?vue&type=template&id=0fbfb5fd&scoped=true&"
import script from "./v_EmailBoughtTicket.vue?vue&type=script&lang=js&"
export * from "./v_EmailBoughtTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbfb5fd",
  null
  
)

export default component.exports